import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useDashboardStyles = makeStyles((theme: Theme) => ({
  card: {
    cursor: 'pointer',
    width: `${100 / 3}%`,
    position: 'relative',
    padding: theme.spacing(1.5),
  },
  aspectRationHackElement: {
    float: 'left',
    paddingTop: '100%',
  },
  cardTabletLarge: {
    width: '50%',
  },
  cardTablet: {
    width: `${100 / 3}%`,
  },
  cardMobile: {
    width: '50%',
  },
  cardInside: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(3),

    transition: theme.transitions.create(['all'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shortest,
    }),
    boxShadow: theme.custom?.boxShadow[1],
    transform: 'scale3d(1, 1, 1)',
    '&:hover': {
      boxShadow: theme.custom?.boxShadow[3],
      transform: 'scale3d(1.04, 1.04, 1.04)',
    },

    '& > *': { // use ":not(:last-child)" when should there be more than 1 component in there
      marginBottom: theme.spacing(2),
    },
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'inherit',
    flexDirection: 'column',
  },
  cardOrange: {
    backgroundColor: '#F5A623',
  },
  cardBlue: {
    backgroundColor: '#014688',
  },
  cardWhite: {
    backgroundColor: '#fff',
  },
}))
